import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import InitData from "../routes/InitData";

function withAuth<T>(WrapperComponent: React.ElementType) {
  function Auth(props: T) {
    const token = useSelector((state: any) => state.auth.token);
    if (!token) {
      return <Navigate to="/login" />;
    }
    return (
      <>
        <InitData />
        <WrapperComponent {...props} />
      </>
    );
  }
  return Auth;
}
export default withAuth;
